import { TableData, TableRow } from '../../../../elements/common';
import { Translate } from '../../../../elements/Translate';

export function NoResult(props: { colspan: number }) {
    return (
        <TableRow>
            <TableData colspan={props.colspan}>
                <Translate translateKey="common.noResult" />
            </TableData>
        </TableRow>
    );
}
